import { Util } from "../../../../util/util";
// This before tax allocator was derived from the original code where it applied to the following coupon types:
// explicitly: MANAGER_DISCOUNT, NEXT_ORDER_CREDIT, LOYALTY_DISCOUNT, EMPLOYEE_DISCOUNT, EMPLOYEE_CONSUMPTION, PERCENTAGE_OFF_ENTIRE_ORDER, PERCENTAGE_OFF_ALL_ITEMS_IN_CATEGORY, 
// implicitly: MIX_AND_MATCH_PERCENTAGE 
export class ProportionalAllocator {
    allocate(params) {
        const { dItem, oItem, remainingDiscount, remainingTotalPrice } = params;
        const proportional = Util.Float2(dItem.oPrice * remainingDiscount / remainingTotalPrice);
        //currentItemDiscount takes into account discounts applied previously from other coupons and discounts currently being applied through discount redistribution (if applicable)
        const currentItemDiscount = oItem.afterTaxDiscount +
            oItem.beforeTaxDiscount +
            dItem.afterTaxDiscount +
            dItem.beforeTaxDiscount;
        // Item still has room for more discount
        if (currentItemDiscount < dItem.oPrice) {
            const room = dItem.oPrice - currentItemDiscount;
            const allocated = Math.min(room, proportional);
            dItem.beforeTaxDiscount += allocated;
            return {
                allocated,
                wantsRedistribute: 0,
                eligibleForRounding: true,
            };
        }
        return {
            allocated: 0,
            wantsRedistribute: proportional,
            itemPriceRemoved: dItem.oPrice,
            eligibleForRounding: false,
        };
    }
}
//# sourceMappingURL=proportional-allocator.js.map